import React from "react";
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { withRouter } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '2rem 0',
    },
    heading: {
        marginBottom: '1rem',
    },
    footer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        width: '70%',
    }
}));


const MasterModal = (props) => {
    const { isOpen, onClose } = props;
    const classes = useStyles();

    return (
        <React.Fragment>
            <Dialog
                PaperProps={{
                    style: { borderRadius: '20px', width: '35%' }
                }}
                fullWidth={true}
                maxWidth={'xs'}
                open={isOpen}
                onClose={onClose}
                aria-labelledby="max-width-dialog-title"
            >
                <div className={classes.root}>
                    <div>
                        <h3 style={{
                            fontSize: "18px",
                            fontFamily: "Open Sans",
                        }}>Master template successfully updated</h3>
                    </div>
                    {/* <div className={classes.heading}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    name=""
                                    color="primary"
                                />
                            }
                            label="Add this programme to master templates"
                        />
                    </div> */}
                    <div className={classes.footer}>
                        <Button disableElevation onClick={() => {
                            props.history.push('/admin/setup')
                        }} variant="contained" color="secondary" style={{
                            fontSize: "14px",
                            fontFamily: "Open Sans",
                            lineHeight: "16px",
                            height: "35px",
                            textTransform: "none"
                        }}>Finish</Button>
                    </div>
                </div>
            </Dialog>
        </React.Fragment>
    )
}

export default withRouter(MasterModal);
